export default __webpack_public_path__ + "atomic/_patterns/03-organisms/card-grid/_card-grid.twig";